
export default
	props: block: Object
	computed:	news: -> @block.news
